import { render, staticRenderFns } from "./TransferResetPassword.vue?vue&type=template&id=2a88f8a0&"
import script from "./TransferResetPassword.vue?vue&type=script&lang=js&"
export * from "./TransferResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports